import { Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";

interface ExpandProps {
  text: string;
  maxCharsReceived: number;
}
export const ExpandableText = (props: ExpandProps) => {
  const { text, maxCharsReceived } = props;
  const [maxChars, setMaxChars] = useState(maxCharsReceived);
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    if (expanded) {
      setMaxChars(maxCharsReceived);
    } else {
      setMaxChars(text?.length);
    }
    setExpanded(!expanded);
  };

  return (
    <span className="content-text">
      {text ? <>{text?.slice(0, maxChars)} </> : "N/A"}
      {text?.length >= maxChars && (
        <span
          style={{
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
            color: "#44799C",
          }}
          onClick={toggleExpanded}
        >
          {expanded ? "...Less" : "...More"}
        </span>
      )}
    </span>
  );
};

export const CollapsibleList = ({ data }: { data: any }) => {
  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => setShowAll(!showAll);

  const visibleItems = showAll ? data : data.slice(0, 2);

  return (
    <div>
      {visibleItems?.length > 0
        ? visibleItems?.map((each: any, index: number) => (
            <>
              <Typography variant="body2" component="div" fontWeight={600}>
                {each.referenceCode ?? "NA"}
              </Typography>
              {each?.referenceMessages?.map(
                (item: any, messageIndex: number) => (
                  <>
                    <Typography
                      variant="body2"
                      component="div"
                      style={{ position: "relative", paddingLeft: 25 }}
                    >
                      <CheckIcon
                        fontSize={"small"}
                        style={{
                          verticalAlign: "middle",
                          position: "absolute",
                          left: 0,
                        }}
                      />
                      {item ?? "NA"}
                      {!showAll && index === 1 && data.length > 2 && (
                        <span
                          onClick={toggleShowAll}
                          style={{
                            cursor: "pointer",
                            fontWeight: "bold",
                            fontSize: "12px",
                            color: "#44799C",
                            marginLeft: 5,
                          }}
                        >
                          ...More
                        </span>
                      )}
                      {showAll &&
                        data.length > 2 &&
                        index === data.length - 1 &&
                        messageIndex ===
                          each?.referenceMessages?.length - 1 && (
                          <span
                            onClick={toggleShowAll}
                            style={{
                              cursor: "pointer",
                              fontWeight: "bold",
                              fontSize: "12px",
                              color: "#44799C",
                              marginLeft: 5,
                            }}
                          >
                            ...Less
                          </span>
                        )}
                    </Typography>
                  </>
                )
              )}
            </>
          ))
        : "NA"}
    </div>
  );
};
